import CommonButton from '../../../../components/common-components/button/CommonButton';
import footerStyles from '../../../../components/form-components/common-components/FormPopupFooter.module.css';

type AppointmentStepperFooterProps = {
  onClose: () => void;
  onSave: () => void;
  isLoading: boolean;
  saveLabel: string;
};

const AppointmentStepperFooter = ({
  onClose,
  onSave,
  isLoading,
  saveLabel,
}: AppointmentStepperFooterProps) => {
  return (
    <div className={footerStyles.actions}>
      <CommonButton
        type="outline"
        className={footerStyles.cancelBtn}
        onClick={onClose}
        disabled={isLoading}
      >
        İptal
      </CommonButton>
      <CommonButton
        type="primary"
        className={footerStyles.saveBtn}
        onClick={onSave}
        disabled={isLoading}
        loading={isLoading}
      >
        {saveLabel}
      </CommonButton>
    </div>
  );
};

export default AppointmentStepperFooter;
